var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "0 15px" }, on: { click: _vm.toggleClick } },
    [
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isActive,
            expression: "isActive",
          },
        ],
        staticClass: "el-icon-s-fold hamburger-icon",
      }),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isActive,
            expression: "!isActive",
          },
        ],
        staticClass: "el-icon-s-unfold hamburger-icon",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }